import styled from "styled-components"

export const SideMenu = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background: white;
  width: 0px;
  z-index: 40;
  transition: all 0.2s ease;

  &.active {
    width: 712px;
    padding: 40px 24px;

    @media (max-width: 768px) {
      border-radius: 8px 8px 0px 0px;
      width: 100%;
      padding: 5px;
      top: 0;
    }
  }
`

export const Background = styled.div`
  transition: all 0.1s ease;
  z-index: -1px;

  &.active {
    position: fixed;
    z-index: 39;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 51, 0.8);

    @media (max-width: 768px) {
      background: none;
    }
  }
`

export const BodyContainer = styled.div`
  max-width: 665px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 91vh;
  padding-bottom: 50px;

  @media (max-width: 768px) {
    max-width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    height: 100%;
  }
`

export const LogoContainer = styled.div`
  width: 664px;
  height: 169px;
  background-color: #000033;
  padding: 30px 25px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 343px;
    height: 172px;
    padding: 23px 16px;
    margin-inline: auto;
    margin-top: 16px;
  }
`

export const AccordionContainer = styled.div`
  width: 664px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 343px;
    margin-inline: auto;
  }
`

export const TickethossLogoContainer = styled.img`
  width: 50%;
  height: 121px;
  max-width: 214px;

  @media (max-width: 768px) {
    width: 50%;
    height: 58px;
    max-width: 128px;
  }
`

export const HeaderText = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 2em;
  line-height: 40px;
  color: #fff;
  margin-bottom: 10px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.75em;
    line-height: 32px;
  }
`

export const CloseButton = styled.img`
  cursor: pointer;
  position: fixed;
  top: 45px;
  bottom: 0;
  right: 732px;
  z-index: 100;
  color: white;
  transition: all 0.2s ease;

  @media (max-width: 768px) {
    display: none;
  }
`

export const CloseWrapper = styled.img`
  font-size: 1.8em;
  transition: all 0.2s ease;
  margin-left: 10px;
  margin-top: 10px;

  @media (min-width: 768px) {
    display: none;
  }
`

export const BuyTicketContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`

export const BuyTicketMobileButton = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    display: none;
  }
`

export const TicketTextHeader = styled.p`
  font-size: 1.125em;
  line-height: 24px;
  font-weight: 700;
  border-bottom: 2px solid rgba(0, 0, 51, 0.05);
  color: #000033;
  margin-bottom: 24px;
  padding-bottom: 8px;
  margin-top: 40px;
`
